module.exports = {
  "country": "DE",
  "artist": "Lena Valaitis",
  "song": "Johnny Blue",
  "year": "1981",
  "place": "2",
  "spotify": "5e6KfjLDK12b19zGnHaDf4"
};